import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import LangEn from "../../lang/en.json";
import { IntlProvider } from 'react-intl';

function QueryProvider({ children }) {
  return (
    <IntlProvider locale={"ar"} defaultLocale="ar" messages={LangEn}>
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
    </IntlProvider>

  );
}

export default QueryProvider;
